<script>
	export default {
		data() {
			return {
				images: []
			};
		},
		mounted() {
			const queryImages = this.$route.query.images;
			if (queryImages) {
				this.images = JSON.parse(queryImages);
			}
		},
		methods: {
			// 删除图片方法
			removeImage(index) {
				this.images.splice(index, 1);
			}
		}
	};
</script>

<template>
	<div>
		<h2>已选择的图片</h2>
		<div class="image-grid">
			<div class="image-wrapper" v-for="(img, index) in images" :key="index">
				<img :src="img" class="image" />
				<button class="delete-btn" @click="removeImage(index)">✕</button>
			</div>
		</div>
	</div>
</template>
<style scoped>
	.image-grid {
		display: flex;
		flex-wrap: wrap;
		gap: 10px;
	}

	.image-wrapper {
		position: relative;
		width: calc(33.33% - 10px);
		/* 每行三个，减去间距 */
		padding-top: 33.33%;
		/* 使 div 高度等于宽度，实现正方形 */
		overflow: hidden;
	}

	.image {
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		width: 100%;
		height: 100%;
		object-fit: cover;
		border-radius: 4px;
	}

	/* 删除按钮样式 */
	.delete-btn {
		position: absolute;
		top: 5px;
		right: 5px;
		bottom: 5px;
		left: 5px;
		background-color: rgba(0, 0, 0, 0.5);
		color: white;
		border: none;
		border-radius: 50%;
		width: 20px;
		height: 20px;
		font-size: 14px;
		cursor: pointer;
		line-height: 20px;
		text-align: center;
	}
</style>